import { NativeModules, Platform } from 'react-native'

// Values must match the allow-list in DIANativeCallModule.callScreenDidLayout.
export enum CallScreenMarker {
  Incoming = 'call-incoming-root',
  Video = 'call-video-root',
}

interface CallScreenLayoutModule {
  callScreenDidLayout?: (marker: CallScreenMarker) => void
}

// Refresh the existing Android call view after layout without remounting its video stream.
export function callScreenDidLayout(marker: CallScreenMarker) {
  if (Platform.OS !== 'android') return
  const nativeCallModule = NativeModules.DIANativeCallModule as CallScreenLayoutModule | undefined
  // Older native binaries may not expose the redraw method yet.
  nativeCallModule?.callScreenDidLayout?.(marker)
}
